/* eslint-disable import/prefer-default-export */
import {
  SELECT_PROFILE,
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  EDIT_PROFILE,
  CANCEL_EDIT_PROFILE,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  PROFILE_ERRORS,
} from '../constants/action-types/profile';

export const selectProfile = () => ({
  type: SELECT_PROFILE,
});

export const getProfile = id => ({
  type: GET_PROFILE,
  id,
});

export const getProfileSuccess = data => ({
  type: GET_PROFILE_SUCCESS,
  data,
});

export const editProfile = () => ({
  type: EDIT_PROFILE,
});

export const cancelEditProfile = () => ({
  type: CANCEL_EDIT_PROFILE,
});

export const updateProfile = (id, data) => ({
  type: UPDATE_PROFILE,
  id,
  data,
});

export const updateProfileSuccess = data => ({
  type: UPDATE_PROFILE_SUCCESS,
  data,
});

export const profileErrors = () => ({
  type: PROFILE_ERRORS,
});
